<template><div>
  <section class="bg-white pt-1">
    <div class="container-xxl">
      <div class="row">
        <div class="col-lg-6 pb-4">

          <h1 class="display-5 fw-bold mb-4">
            Ative o seu Chat Booster <span class="text-primary">com o nosso código</span>
          </h1>
          <p class="lead mb-0">
            O método mais simples de ativar o Chat Booster em seu site é com nosso código, acompanhe o tutorial abaixo:
          </p>
        </div>
        <div class="col-lg-6 d-none d-lg-block bg-logo-hero" />
        <div class="col-lg-6 mb-2">
          <div class="d-flex">
            <div class="display-3 text-primary fw-medium me-3 d-none d-lg-block">
              1.
            </div>
            <div class="d-flex flex-column">
              <h3 class="fs-1 fw-bolder">
                <span class="text-primary me-1 d-inline d-lg-none">1.</span>
                Código de ativação
              </h3>
              <p class="lead">
                Copie o código e o insira na página do site que deseja mostrar o vídeo, você pode inseri-lo dentro do código de sua página, antes do elemento
                 <span
                  class="badge bg-primary"
                >&lt;/body&gt;</span>
              </p>
              <div class="text-break">
                <div>
                  <div class="sc-fzoyAV fQsatj">
                    <div class="sc-fzoLag BNtsP card">

                      <code id="codigo-embad-chat-booster">
                        {{ `
                          &lt;script type="text/javascript"&gt;
                          ${script}
                             &lt;/script&gt;
                      ` }}
                      </code>
                    </div>
                    <b-button
                        id="btn-copiar-codigo"
                      variant="primary"
                      pill
                      @click="copiarTexto"
                    >
                      <feather-icon
                        icon="CopyIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">Copia Codigo</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>

</template>

<script>
export default {
  data() {
    return {
      VUE_APP_HOST_BUCKET_CHAT: process.env.VUE_APP_HOST_BUCKET_CHAT,
    }
  },

  computed: {
    getUserData() {
      return localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
    },
    script() {
      console.log(this.VUE_APP_HOST_BUCKET_CHAT)
      const urlScript = this.VUE_APP_HOST_BUCKET_CHAT
      return `(function (w, r, l, d) {
               try { var h = r.head || r.getElementsByTagName("head")[0], s = r.createElement("script");
            s.defer = true;
            s.setAttribute("type", "module");
            s.setAttribute("src", l);
            w.idbooster = d;
            h.appendChild(s);
        } catch (e) { }
    })(window, document, "${urlScript}", "${this.getUserData.uuid}");
            `
    },
  },
  mounted() {
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'AtivacaoLeads')
  },
  methods: {
    copiarTexto() {
      const textoCopiado = document.querySelector('#codigo-embad-chat-booster')
      const el = document.createElement('textarea')
      el.value = `${textoCopiado.innerText}`
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$message({
        message: 'Código de embed JS copiado para área de transferência',
        type: 'success',
      })
    },
  },
}
</script>

<style scoped lang="scss">

</style>
